<template>
  <div class="page-wrap">
    <div style="height: 100%" v-show="pageType === 1">
      <div class="filter-title">
        <span class="title-text">数据总览</span>
        <div class="select-wrap">
          <el-select
            v-model="formSearch.platform"
            placeholder="请选择平台"
            @change="changePlatform"
          >
            <el-option label="全部平台" :value="null"></el-option>
            <el-option
              v-for="item in platTypes"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
          <el-select
            @change="changePlatform"
            v-model="formSearch.team"
            filterable
            multiple
            collapse-tags
            placeholder="请选择工作室"
            class="multiple-select"
            style="margin-left: 12px; width: 300px"
            popper-class="select-popver-fixed"
          >
            <el-checkbox
              class="select-popver-fixed-checkbox"
              v-model="checkedTeam"
              @change="selectAllTeam($event, 'check')"
              >全选</el-checkbox
            >
            <el-option
              v-for="item in teamList"
              :key="item"
              :label="item"
              :value="item"
            >
            </el-option>
          </el-select>
          <product-select
            :value.sync="formSearch.afid"
            :multiple="true"
            placeholder="请选择应用"
            class="all-select"
            style="margin-left: 12px; width: 300px"
            popper-class="select-popver-fixed"
            :searchParams="{
              osTypeList: formSearch.platform,
              productGroupNameList: formSearch.team,
            }"
          >
          </product-select>
          <el-select
            style="margin: 0 12px; width: 200px"
            class="multiple-select"
            v-model="formSearch.mediaList"
            placeholder="全部渠道"
            filterable
            multiple
            collapse-tags
          >
            <el-option
              v-for="item in mediaList"
              :key="item"
              :label="item"
              :value="item"
            >
            </el-option>
          </el-select>
          <areaMultiSelect
            :value.sync="formSearch.geo"
            :optionsList="countryList"
          >
          </areaMultiSelect>
          <el-select
            v-model="formSearch.accountGroupCodes"
            multiple
            collapse-tags
            style="margin-left: 12px; width: 200px"
            placeholder="请选择域名组"
            clearable
          >
            <el-option
              v-for="item in accountGroupCodeList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
          <el-date-picker
            v-model="formSearch.formdate"
            type="daterange"
            align="right"
            unlink-panels
            value-format="yyyyMMdd"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :picker-options="pickerOptions"
            style="width: 320px; margin: 0 12px"
          ></el-date-picker>
          <el-button type="primary" class="search-btn" @click="handlerSearch"
            >查询</el-button
          >
          <el-button class="search-btn" @click="handlerReset">重置</el-button>
        </div>
      </div>

      <div class="chart-content">
        <!-- 收支-当前ROI -->
        <BudgetChart
          @showDetail="showDetail"
          :formSearch="formSearch"
          class="chart odd-chart"
          ref="budgetChart"
        ></BudgetChart>
        <!-- 新增ROI&支出占比 -->
        <BudgetPie
          :formSearch="formSearch"
          class="chart"
          ref="budgetPie"
        ></BudgetPie>
        <TrendChart
          @showDetail="showDetail"
          :formSearch="formSearch"
          class="chart odd-chart"
          ref="productIncome"
          fieldKey="productIncome"
          title="产品-收入趋势"
        ></TrendChart>
        <TrendChart
          @showDetail="showDetail"
          :formSearch="formSearch"
          class="chart"
          ref="countryIncome"
          fieldKey="countryIncome"
          title="地区-收入趋势"
        ></TrendChart>
        <TrendChart
          @showDetail="showDetail"
          :formSearch="formSearch"
          class="chart odd-chart"
          ref="productAdd"
          fieldKey="productAdd"
          title="产品-新增趋势"
        ></TrendChart>
        <TrendChart
          @showDetail="showDetail"
          :formSearch="formSearch"
          class="chart"
          ref="productOutlay"
          fieldKey="productOutlay"
          title="产品-支出趋势"
        ></TrendChart>
        <TrendChart
          @showDetail="showDetail"
          :formSearch="formSearch"
          class="chart odd-chart"
          ref="countryAdd"
          fieldKey="countryAdd"
          title="地区-新增趋势"
        ></TrendChart>
        <TrendChart
          @showDetail="showDetail"
          :formSearch="formSearch"
          class="chart"
          ref="countryOutlay"
          fieldKey="countryOutlay"
          title="地区-支出趋势"
        ></TrendChart>
        <TrendChart
          @showDetail="showDetail"
          :formSearch="formSearch"
          class="chart odd-chart"
          ref="channelAdd"
          fieldKey="channelAdd"
          title="渠道-新增趋势"
        ></TrendChart>
        <TrendChart
          @showDetail="showDetail"
          :formSearch="formSearch"
          class="chart"
          ref="channelOutlay"
          fieldKey="channelOutlay"
          title="渠道-支出趋势"
        ></TrendChart>
        <TrendChart
          @showDetail="showDetail"
          :formSearch="formSearch"
          class="chart odd-chart"
          ref="channelIncome"
          fieldKey="channelIncome"
          title="渠道-收入趋势"
        ></TrendChart>
        <TrendChart
          @showDetail="showDetail"
          :formSearch="formSearch"
          class="chart"
          ref="countryPurchaseIncome"
          fieldKey="countryPurchaseIncome"
          title="地区-内购收入趋势"
        ></TrendChart>
        <TrendBar
          class="chart odd-chart"
          :formSearch="formSearch"
          ref="purchaseIncome"
          fieldKey="purchaseIncome"
          title="内购收入趋势"
        ></TrendBar>
        <!--内购收入占比 -->
        <PurchasePie
          :formSearch="formSearch"
          class="chart"
          ref="purchasePie"
        ></PurchasePie>
        <TrendChart
          @showDetail="showDetail"
          :formSearch="formSearch"
          class="chart odd-chart"
          ref="productPurchaseIncome"
          fieldKey="productPurchaseIncome"
          title="产品-内购收入趋势"
        ></TrendChart>
        <TrendChart
          @showDetail="showDetail"
          :formSearch="formSearch"
          class="chart"
          ref="countryPurchaseArpu"
          fieldKey="countryPurchaseArpu"
          title="地区-内购活跃arpu趋势"
        ></TrendChart>
        <TrendChart
          @showDetail="showDetail"
          :formSearch="formSearch"
          class="chart odd-chart"
          ref="countryAdArpu"
          fieldKey="countryAdArpu"
          title="地区-广告活跃arpu趋势"
        ></TrendChart>
      </div>
    </div>
    <!-- 表格子页面 -->
    <div v-if="pageType === 2">
      <table-detail
        @goBack="goBack"
        :fieldParams="fieldParams"
        :formSearch="formSearch"
      ></table-detail>
    </div>
  </div>
</template>

<script>
import { getTeamList } from "@/api/bi-board.js";
import { platTypes } from "./config";
import { getCountryListFetch } from "@/api/api";
import BudgetChart from "./components/budgetChart.vue";
import BudgetPie from "./components/budgetPie.vue";
import PurchasePie from "./components/purchasePie.vue";
import TrendChart from "./components/trendChart.vue";
import TrendBar from "./components/trendBar.vue";
import TableDetail from "./components/tableDetail.vue";
import moment from "moment";
import areaMultiSelect from "@/components/areaMultiSelect.vue";
import { getmediaSourceFetch } from "@/api/api";
export default {
  components: {
    BudgetChart,
    BudgetPie,
    TrendChart,
    TableDetail,
    areaMultiSelect,
    TrendBar,
    PurchasePie,
  },

  data() {
    return {
      platTypes,
      pageType: 1,
      fieldParams: {},
      accountGroupCodeList: JSON.parse(
        localStorage.getItem("accountGroupCodeList") || "[]"
      ),
      formSearch: {
        platform: null,
        team: [],
        afid: [],
        mediaList: [],
        geo: [],
        accountGroupCodes: [],
        formdate: [
          moment().subtract(15, "days").format("YYYYMMDD"),
          moment().subtract(2, "days").format("YYYYMMDD"),
        ],
      },
      checked: false,
      checkedGeo: false,
      checkedTeam: false,
      teamList: [],
      countryList: [],
      mediaList: [],
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now() - 3600 * 1000 * 24 * 2;
        },
      },
    };
  },

  computed: {},

  watch: {},

  mounted() {
    this.initSelect();
    this.handlerSearch();
    // window.addEventListener("resize", () => {
    //   this.handlerSearch();
    // });
  },

  methods: {
    initSelect() {
      // 地区
      getCountryListFetch().then((res) => {
        this.countryList = res.countryList;
      });
      getTeamList().then((res) => {
        this.teamList = res.data;
      });
      getmediaSourceFetch().then((res) => {
        this.mediaList = res.mediaList;
      });
    },
    selectAllTeam(event, value) {
      if (event) {
        this.formSearch.team = this.teamList;
      } else {
        value == "check" ? (this.formSearch.team = []) : null;
      }
    },
    async handlerSearch() {
      try {
        // 先设置所有图表的 loading 状态为 true
        const allRefs = [
          'budgetChart', 'budgetPie', 'productIncome', 'countryIncome',
          'channelIncome', 'productAdd', 'productOutlay', 'countryAdd',
          'countryOutlay', 'channelAdd', 'channelOutlay', 'purchaseIncome',
          'purchasePie', 'countryPurchaseIncome', 'productPurchaseIncome',
          'countryPurchaseArpu', 'countryAdArpu'
        ];
        allRefs.forEach(refName => {
          if (this.$refs[refName] && this.$refs[refName].setLoading) {
            this.$refs[refName].setLoading(true);
          }
        });

        console.log(11111)
        // 第一批：4个接口 - 使用 allSettled 确保即使某个失败也不影响其他
        await Promise.allSettled([
          this.$refs.budgetChart.getCharts(),
          this.$refs.budgetPie.getCharts(),
          this.$refs.productIncome.getCharts(),
          this.$refs.countryIncome.getCharts(),
        ]);
        console.log(2222)
        // 第二批：4个接口
        await Promise.allSettled([
          this.$refs.channelIncome.getCharts(),
          this.$refs.productAdd.getCharts(),
          this.$refs.productOutlay.getCharts(),
          this.$refs.countryAdd.getCharts(),
        ]);
        console.log(3333)

        // 第三批：4个接口
        await Promise.allSettled([
          this.$refs.countryOutlay.getCharts(),
          this.$refs.channelAdd.getCharts(),
          this.$refs.channelOutlay.getCharts(),
          this.$refs.purchaseIncome.getCharts(),
        ]);

        // 第四批：4个接口
        await Promise.allSettled([
          this.$refs.purchasePie.getCharts(),
          this.$refs.countryPurchaseIncome.getCharts(),
          this.$refs.productPurchaseIncome.getCharts(),
          this.$refs.countryPurchaseArpu.getCharts(),
          this.$refs.countryAdArpu.getCharts(),
        ]);
      } catch (error) {
        console.error('图表加载失败:', error);
      }
    },
    handlerReset() {
      this.formSearch = {
        platform: null,
        team: [],
        afid: [],
        mediaList: [],
        geo: [],
        accountGroupCodes: [],
        formdate: [
          moment().subtract(15, "days").format("YYYYMMDD"),
          moment().subtract(2, "days").format("YYYYMMDD"),
        ],
      };
    },
    changePlatform() {
      this.getList();
      this.formSearch.afid = [];
    },
    showDetail(obj) {
      this.pageType = 2;
      this.fieldParams = obj;
    },
    goBack() {
      this.pageType = 1;
    },
  },
};
</script>

<style lang="less" scoped>
.page-wrap {
  padding: 16px 16px 0px 16px;
  box-sizing: border-box;
  height: calc(100vh - 50px);
  overflow: hidden;
  .filter-title {
    border-radius: 4px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.12);
    padding: 16px 24px 16px 24px;
    .title-text {
      color: rgba(0, 0, 0, 0.85);
      font-weight: bold;
      font-size: 16px;
    }
  }
  .select-wrap {
    margin-top: 16px;
    display: flex;
    .search-btn {
    }
  }

  .chart-content {
    height: calc(100% - 164px);
    overflow: auto;
    margin-top: 16px;
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    .chart {
      width: calc(50% - 60px);
      padding: 16px 24px 16px 24px;
      border-radius: 4px;
      background: rgba(255, 255, 255, 1);
      box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.12);
    }
    .odd-chart {
      margin-right: 20px;
    }
  }
}
.el-form-item {
  margin-bottom: 0px;
}
.date {
  margin-bottom: 10px;
}
.el-checkbox {
  width: 95%;
  text-align: right;
}
.multiple-select {
  width: 200px;
  /deep/ .el-tag.el-tag--info:first-child {
    max-width: 100px;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
</style>
<style lang="less">
.all-select .el-select__tags-text {
  max-width: 62px;
  overflow: hidden;
  display: inline-block;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.all-select .el-tag__close {
  margin-bottom: 13px;
}
.report_select ul li:nth-child(2) {
  // margin-top: 2% !important;
}
.select-popver-fixed {
  .el-select-dropdown__list {
    padding-top: 0px;
    position: relative;
  }
  .select-popver-fixed-checkbox {
    position: sticky;
    top: 0px;
    height: 24px;
    line-height: 29px;
    background: white;
    z-index: 999;
    margin-bottom: 8px;
  }
}
</style>
